import { render, staticRenderFns } from "./tel_chating.vue?vue&type=template&id=d15a3810&scoped=true&"
import script from "./tel_chating.vue?vue&type=script&lang=js&"
export * from "./tel_chating.vue?vue&type=script&lang=js&"
import style0 from "./tel_chating.vue?vue&type=style&index=0&id=d15a3810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a3810",
  null
  
)

export default component.exports